import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box sx={styles.container}>
      <Typography variant="body10Regular" sx={styles.text}>
        {t("layout.footer.copyRights")}
      </Typography>
    </Box>
  );
};

export default Footer;

const styles = {
  container: {
    width: "100%",
    padding: "10px 0",
    textAlign: "center",
    backgroundColor: "#FFF",
  },
  text: {
    color: "#4B504B",
  },
};
